import { AutoComplete, ISelectType, useFetch, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { insuranceRegisterList } from "../../../../../../../services/ticketAutomationReceivedRuleInsurance.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const InsuranceExternalIdThen = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  // Card #3070 (confirmado com Mauricio, 2026-08-26): agora que a regra tem um Tipo de Convênio
  // próprio, o Convênio passa a ser filtrado por esse tipo, em vez de sempre listar todos.
  const insuranceTypeExternalIdThen = useWatch({
    control,
    name: "insuranceTypeExternalIdThen",
  });

  const { sendRequest } = useFetch(insuranceRegisterList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const typeCode = insuranceTypeExternalIdThen?.id;

  const fetchOptions = useCallback(
    async (currentTypeCode: typeof typeCode, isStale: () => boolean) => {
      const { data, success } = await sendRequest(
        currentTypeCode ? { typeCode: currentTypeCode } : {},
      );
      if (data && success && !isStale()) {
        setOptions(
          data.map((item) => ({
            id: String(item.identifier),
            name: item.insuranceName,
          })),
        );
      }
    },
    [sendRequest],
  );

  useEffect(() => {
    let stale = false;
    fetchOptions(typeCode, () => stale);
    return () => {
      stale = true;
    };
  }, [fetchOptions, typeCode]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={options}
        name="insuranceExternalIdThen"
        size="small"
        fullWidth
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "insurance_external_id_then")}
      />
    </Grid>
  );
});
